import { IServerResponse } from "app/interface";

export interface ContractTemplateState {
    contractTemplateList: Array<any>;
    contractTemplateById: any;
    addContractTemplateResponse: IServerResponse;
    updateContractTemplateResponse: IServerResponse;
    deleteContractTemplateResponse: IServerResponse;
}

export const initialState: ContractTemplateState = {
    contractTemplateList: null,
    contractTemplateById: null,
    addContractTemplateResponse: null,
    updateContractTemplateResponse: null,
    deleteContractTemplateResponse: null
}
